import React from 'react';
import { Button } from '../ui/button';
import { Card, CardContent } from '../ui/card';
import { Camera, RotateCcw } from 'lucide-react';

export const CameraSection = ({ videoRef, canvasRef, photo, facingMode, serverTime, location, user, locationName, onTakePhoto, onToggleCamera }) => {
  return (
    <Card className="mb-4 border-indigo-100/50 overflow-hidden">
      <CardContent className="p-0">
        <div className="camera-container mx-auto">
          {!photo ? (
            <>
              <video
                ref={videoRef}
                autoPlay
                playsInline
                muted
                className="camera-video"
                style={{ transform: facingMode === 'user' ? 'scaleX(-1)' : 'none' }}
              />
              <div className="camera-overlay">
                <div className="flex justify-end">
                  <Button
                    size="sm"
                    variant="secondary"
                    className="bg-white/20 backdrop-blur"
                    onClick={onToggleCamera}
                  >
                    <RotateCcw className="w-4 h-4" />
                  </Button>
                </div>
                <div className="camera-guide" />
                <div className="flex justify-center pb-4">
                  <Button
                    size="lg"
                    className="w-16 h-16 rounded-full bg-white text-indigo-950 hover:bg-gray-100"
                    onClick={onTakePhoto}
                    data-testid="capture-btn"
                  >
                    <Camera className="w-8 h-8" />
                  </Button>
                </div>
              </div>
            </>
          ) : (
            <div className="photo-preview">
              <img src={photo} alt="Preview" className="w-full h-full object-cover" />
              <div className="watermark-preview">
                <p className="font-medium">{user?.nama}</p>
                <p>{serverTime?.toLocaleString('id-ID')}</p>
                {location && (
                  <p>{location.latitude.toFixed(6)}, {location.longitude.toFixed(6)}</p>
                )}
                <p>{locationName || '-'}</p>
              </div>
            </div>
          )}
        </div>
        <canvas ref={canvasRef} className="hidden" />
      </CardContent>
    </Card>
  );
};
